"use client"
import { Badge, Button, UncontrolledTooltip } from "reactstrap"

const ServiceTableItem = ({ service, handleShow, handleDelete, handleUpdateStatus }) => {
  const getStatusBadge = (isActive) => {
    return isActive ? <Badge color="success">Active</Badge> : <Badge color="danger">Inactive</Badge>
  }

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(price)
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    })
  }

  const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
  }

  const truncateText = (text, maxLength = 30) => {
    if (!text) return ""
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text
  }

  const handleStatusChange = (newStatus) => {
    const statusValue = newStatus === "active" ? 1 : 0
    if (statusValue !== service.is_active) {
      if (window.confirm(`Change service status to ${newStatus}?`)) {
        handleUpdateStatus(service.id, statusValue)
      }
    }
  }

  return (
    <tr>
      <td className="service_id">
        <div className="d-flex align-items-center">
          <div className="flex-shrink-0">
            <span className="fw-semibold">#{service.id}</span>
          </div>
        </div>
      </td>

      <td className="service">
        <div className="d-flex align-items-center">
          {service.image_url && (
            <div className="flex-shrink-0 me-3">
              <img
                src={service.image_url || "/placeholder.svg"}
                alt={service.title}
                className="avatar-sm rounded"
                style={{ width: "40px", height: "40px", objectFit: "cover" }}
              />
            </div>
          )}
          <div className="flex-grow-1">
            <h6 className="mb-1">{truncateText(service.title || "Service", 25)}</h6>
            <p className="text-muted mb-0 small">{truncateText(service.description || "", 40)}</p>
          </div>
        </div>
      </td>

      <td className="provider">
        <div>
          <h6 className="mb-1">{service.user?.name || "Unknown Provider"}</h6>
          <p className="text-muted mb-0 small">{service.user?.email}</p>
          <p className="text-muted mb-0 small">
            {service.user?.account_type_id === 1
              ? "Influencer"
              : service.user?.account_type_id === 2
                ? "Business"
                : "User"}
          </p>
        </div>
      </td>

      <td className="category">
        <div>
          <h6 className="mb-1">{service.category?.name || "No Category"}</h6>
          {service.category?.description && (
            <p className="text-muted mb-0 small">{truncateText(service.category.description, 30)}</p>
          )}
        </div>
      </td>

      <td className="price">
        <span className="fw-semibold text-success">{formatPrice(service.price)}</span>
      </td>

      <td className="status">{getStatusBadge(service.is_active)}</td>

      <td className="created_at">
        <span>{formatDateTime(service.created_at)}</span>
      </td>

      <td>
        <div className="d-flex gap-2">
          <div className="show">
            <Button
              color="primary"
              size="sm"
              id={`show-${service.id}`}
              onClick={() => handleShow(service)}
              className="btn-icon"
            >
              <i className="ri-eye-fill"></i>
            </Button>
            <UncontrolledTooltip placement="top" target={`show-${service.id}`}>
              View Details
            </UncontrolledTooltip>
          </div>

          <div className="status-update">
            <div className="dropdown">
              <Button
                color="info"
                size="sm"
                id={`status-${service.id}`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
                className="btn-icon"
              >
                <i className="ri-settings-line"></i>
              </Button>
              <UncontrolledTooltip placement="top" target={`status-${service.id}`}>
                Update Status
              </UncontrolledTooltip>
              <ul className="dropdown-menu">
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => handleStatusChange("active")}
                    disabled={service.is_active === 1}
                  >
                    <i className="ri-check-line me-2"></i>
                    Activate
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item text-danger"
                    onClick={() => handleStatusChange("inactive")}
                    disabled={service.is_active === 0}
                  >
                    <i className="ri-close-line me-2"></i>
                    Deactivate
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className="remove">
            <Button
              color="danger"
              size="sm"
              id={`delete-${service.id}`}
              onClick={() => handleDelete(service.id)}
              className="btn-icon"
            >
              <i className="ri-delete-bin-fill"></i>
            </Button>
            <UncontrolledTooltip placement="top" target={`delete-${service.id}`}>
              Delete Service
            </UncontrolledTooltip>
          </div>
        </div>
      </td>
    </tr>
  )
}

export default ServiceTableItem
